

























import { Component, Mixins } from 'vue-property-decorator'
import { searchToWhereUrl } from '@core/utils/jump'
import RecommendItem from './mixins/RecommendItem'
import { toNumber } from 'lodash'

@Component
export default class ShopItem extends Mixins(RecommendItem) {
  get storeCategory() {
    return (this.value.storeCategory && this.value.storeCategory.split(',')) || []
  }

  get goDetailExposure() {
    const { businessId, businessName } = this.value
    return `200019||${JSON.stringify({ popid: businessId, name: businessName, tabname: this.tab.tabName })}`
  }
  goDetail() {
    const { businessId, businessName } = this.value
    this.$newClickTracker({ ...this.pageTrackParams, clickId: '200019', positionParam: { popid: businessId, name: businessName, tabname: this.tab.tabName } })
  }

  get imgUrl() {
    let url = this.value.photo || this.value.icon
    if (this.value.storeVideoUrl && this.value.storeVideoUrl.length > 0) {
      url = this.value.storeVideoPicture;
    }
    return url
  }

  get imgHeight() {
    let photoH = 256
    const kItemWidth = 342
    if (this.value.storeVideoUrl && this.value.storeVideoUrl.length > 0 ) {
        ///优先显示顺序:商品视频 > 商品首图
        const h = toNumber(this.value.storeVideoHeight) || 0
        const w = toNumber(this.value.storeVideoWidth) || 0
        if (h > 0 && w > 0) {
            photoH = h*1.0/w*kItemWidth;
            //竖版图最大宽高比9：16，横版图最小宽高比4：3
            const rate = w*1.0/h;
            const rateDefV = 9.0/16;
            const rateDefH = 4.0/3;
            if (h >= w) {
                //竖版
                if (rate < rateDefV) {
                    photoH = kItemWidth*1.0/rateDefV;
                }
            } else {
                //横版
                if (rate > rateDefH) {
                    photoH = kItemWidth*1.0/rateDefH;
                }
            }
        }
    }
    return photoH
  }

  get linkUrl() {
    const { isSpot, businessType, businessId } = this.value
    return this.kwtarget(searchToWhereUrl({ toShop: true, businessType, businessId, isSpot }))
  }
}
